import axiosInstance from "../axios_instance";

export async function createCallBackRequest(body) {
  try {
    return await axiosInstance.post(`callBackRequests/increment`, body);
  } catch (error) {
    return error;
  }
}

export async function requestExpertCallback(body) {
  try {
    return await axiosInstance.post(`callBackRequests/request-expert-callback`, body);
  } catch (error) {
    return error;
  }
}

export async function sendNotification(body) {
  try {
    return await axiosInstance.post(`notifications/send`, body);
  } catch (error) {
    return error;
  }
}

export async function createNotification(body) {
  try {
    return await axiosInstance.post(`notifications/`, body);
  } catch (error) {
    return error;
  }
}

export async function getNotificationsByUserID(id) {
  try {
    return await axiosInstance.get(`notifications/${id}`, {
      params: {
        id,
      },
    });
  } catch (error) {
    return error;
  }
}

export async function getNotifications(body) {
  try {
    return await axiosInstance.post(`notifications/get`, body);
  } catch (error) {
    return error;
  }
}

export async function sendEmail(body) {
  try {
    return await axiosInstance.post(`notifications/sendSingleEmail`, body);
  } catch (error) {
    return error;
  }
}

export async function sendSms(body) {
  try {
    return await axiosInstance.post(`notifications/sendSingleSMS`, body);
  } catch (error) {
    return error;
  }
}

export async function sendSingleEmailAndSms(body) {
  try {
    return await axiosInstance.post(`notifications/sendOneEmailAndSMS`, body);
  } catch (error) {
    return error;
  }
}
